// extracted by mini-css-extract-plugin
export default {"tooltip":"qn-z","sharingV2":"rn-z","sharingIconsV2":"sn-z","links":"tn-z","link":"un-z","facebookV2":"vn-z","twitterV2":"wn-z","pinterestV2":"xn-z"};